import { FC } from 'react';

import Skeleton from 'react-loading-skeleton';

interface TableSkeletonProps {
  rows: number;
  columns: number;
  columnWidths: string[];
}

const TableSkeleton: FC<TableSkeletonProps> = ({
  rows,
  columns,
  columnWidths
}) => {
  return (
    <div>
      <div className='mb-2 flex'>
        {columnWidths.map((width, columnIndex) => (
          <div
            key={columnIndex}
            className='mr-6 last-of-type:mr-0'
            style={{ width: width }}
          >
            <Skeleton width='100%' height='2.25rem' />
          </div>
        ))}
      </div>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div key={rowIndex} className={`grid-cols-${columns}`}>
          {Array.from({ length: columns }, (_, columnIndex) => (
            <div key={columnIndex} className='flex'>
              {columnWidths.map((width, columnIndex) => (
                <div
                  key={columnIndex}
                  className='mr-6 last-of-type:mr-0 mb-3'
                  style={{ width: width }}
                >
                  <Skeleton width='100%' height='1rem' />
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
